import React, { useContext, useState, useEffect } from "react";
import { Context } from "../../../Context";
import { SurveyView } from "../../views";
import { SimpleLoading, ModalUtil } from "../../pures";
import { SurveyService } from "../../../services";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import "moment/locale/es";

/**
 * @class SurveyAction
 * @extends {React.Component}
 * @status no delete
 */
const SurveyAction = (props) => {
  const [filter, setFilter] = useState([])
  const [initialLoading, setInitialLoading] = useState(true)
  const [stateSortStart, setStateSortStart] = useState(0)
  const [stateSortLimit, setStateSortLimit] = useState(0)
  const [surveys, setSurveys] = useState([])
  const history = useHistory()
  const url = process.env.REACT_APP_ETICKET_API;
  const surveyService = new SurveyService(url)
  const modalUtil = new ModalUtil()
  const { t } = props
  const { t: transl } = useTranslation('survey', { keyPrefix: 'surveyScreen' })

  useEffect(() => {
    getSurveys()
  }, [])

  const deleteSurvey = async (surveyId) => {
    try {
      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))

      const token = JSON.parse(localStorage.getItem('token')).accessToken

      await surveyService.deleteSurvey(surveyId, token)
      modalUtil.showModal('success', transl('deleteSurvey'), t("modal.pure.title.success"), () => getSurveys())

    } catch (e) {
      modalUtil.showModal('error', transl('errorDelete'), t("modal.pure.title.error"))
    }
  }

  const getSurveys = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('token')).accessToken
      const surveys = await surveyService.getSurveys(token)
      setSurveys(surveys)
      setInitialLoading(false)
    } catch (error) {
      props.setShowError(true)
      setInitialLoading(false)
    }
  }

  const changeStateFilter = (sortStart, sortLimit) => {
    let startState = sortStart;
    let limitState = sortLimit;

    if (startState >= 0 && limitState === undefined) {
      startState += 1;
      if (startState < 3) {
        this.setState({
          stateSortStart: startState,
        });
      } else if (startState === 3) {
        startState = 0;
        this.setState({
          stateSortStart: startState,
        });
      }
    } else if (limitState >= 0 && startState === undefined) {
      limitState += 1;
      if (limitState < 3) {
        this.setState({
          stateSortLimit: limitState,
        });
      } else if (limitState === 3) {
        limitState = 0;
        this.setState({
          stateSortLimit: limitState,
        });
      }
    }
    this.filterByState(startState, limitState);
  };

  const goToDetails = (survey) => {
    const { id: surveyId } = survey
    history.push(`/survey-details?surveyId=${surveyId}`)
  }

  const goToAnswers = (survey) => {
    const { id: surveyId } = survey
    history.push(`/survey-answers/${surveyId}`)
  }

  return (
    <>
      {
        initialLoading ?
          <div className="loading">
            <SimpleLoading />
          </div> : <SurveyView
            surveys={surveys}
            setData={setSurveys}
            filter={filter}
            initialLoading={initialLoading}
            stateSortStart={stateSortStart}
            stateSortLimit={stateSortLimit}
            view={"/"}
            filterByState={changeStateFilter}
            goToDetails={goToDetails}
            deleteSurvey={deleteSurvey}
            goToAnswers={goToAnswers}
          />
      }
    </>
  )
}

function SurveyActionContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return (
    <SurveyAction {...props} t={t} setShowError={setShowError} />
  );
}

export { SurveyActionContainer as default };
